module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"เข้าสู่ระบบ","login.title":"เข้าสู่ระบบ @:common.application.title","username":"ชื่อผู้ใช้งาน","username.placeholder":"ระบุชื่อผู้ใช้งาน","password":"รหัสผ่าน","password.placeholder":"รหัสผ่าน","password.err.pattern":"@:common.password.pattern","loginbtn":"เข้าสู่ระบบ","forgot_password":"ลืมรหัสผ่าน ?","line_login.btn":"ล็อกอินด้วย LINE"}}')
  delete Component.options._Ctor
}
